import { render, staticRenderFns } from "./InternalServerError.vue?vue&type=template&id=4502fae0"
import script from "./InternalServerError.vue?vue&type=script&lang=js"
export * from "./InternalServerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports